import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ddPoaApi, Bi } from '../../utils/api/ddpoa';

// Admin → Companies: where the firm's Powers of Attorney are made (report 404df7d2). The `madeAt` part of the
// workspace's POA defaults (server: services/ddPoaContent.ts): the first choice on the Property Form's Made at
// dropdowns, what a blank box there prints, and what a new POA in the POA module starts with. The wording is the
// firm's own, so it is kept in the setting and never in the code. The one admin save takes the defaults whole, so
// Save reads them afresh and changes only this part: an attorney's date of birth can land on the same row at any
// moment, and the answer's `review`, which the PoaDefaults type leaves out, goes back with the rest.
const MAX_MADE_AT = 400;   // MAX_BI in services/ddPoaContent.ts, which would cut anything longer
const input: React.CSSProperties = {
  width: '100%', padding: '9px 12px', fontSize: 13, borderRadius: 'var(--radius-md)',
  border: '1px solid var(--border-strong)', background: 'var(--c-gray-50)', color: 'var(--text-primary)', outline: 'none',
};
const lbl: React.CSSProperties = { fontSize: 11, fontWeight: 600, color: 'var(--text-secondary)', display: 'block', marginBottom: 4 };
const card: React.CSSProperties = { background: 'var(--bg-surface)', border: '1px solid var(--border)', borderRadius: 'var(--radius-xl)', padding: 20, marginBottom: 16 };
const btn: React.CSSProperties = { padding: '8px 14px', borderRadius: 'var(--radius-md)', border: 'none', background: 'var(--accent)', color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer' };
const errBox: React.CSSProperties = { fontSize: 12, color: '#E24B4A', background: '#FCEBEB', padding: '8px 12px', borderRadius: 'var(--radius-md)', marginBottom: 12 };

export default function PoaMadeAt() {
  const { t } = useTranslation();
  const [en, setEn] = useState('');
  const [th, setTh] = useState('');
  // Nothing can be saved until the wording has been read, or a failed read would save blank boxes over it.
  const [loaded, setLoaded] = useState(false);
  const [err, setErr] = useState(''); const [msg, setMsg] = useState(''); const [saving, setSaving] = useState(false);
  const take = (m: Bi) => { setEn(m.en); setTh(m.th); };
  useEffect(() => {
    ddPoaApi.all().then(r => { take(r.poaDefaults.madeAt); setLoaded(true); }).catch((e: any) => setErr(e.message));
  }, []);
  const save = async () => {
    setSaving(true); setErr(''); setMsg('');
    try {
      const { poaDefaults } = await ddPoaApi.all();
      const r = await ddPoaApi.save({ poaDefaults: { ...poaDefaults, madeAt: { en, th } } });
      take(r.poaDefaults.madeAt); setMsg(t('cs_saved')); setTimeout(() => setMsg(''), 2000);
    } catch (e: any) { setErr(e.message); } finally { setSaving(false); }
  };
  return (
    <div style={card}>
      <div style={{ fontSize: 14, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 4 }}>{t('pf_poa_firm_made_title')}</div>
      <div style={{ fontSize: 12, color: 'var(--text-tertiary)', marginBottom: 14 }}>{t('pf_poa_firm_made_hint')}</div>
      {err && <div style={errBox}>{err}</div>}
      <label style={lbl}>{t('pf_poa_made_at')}</label>
      <input value={en} onChange={e => setEn(e.target.value)} disabled={!loaded} style={input} maxLength={MAX_MADE_AT} />
      <label style={{ ...lbl, marginTop: 12 }}>{t('pf_poa_made_at_th')}</label>
      <input value={th} onChange={e => setTh(e.target.value)} disabled={!loaded} style={input} maxLength={MAX_MADE_AT} />
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 12, marginTop: 14 }}>
        {msg && <span style={{ fontSize: 12, color: '#1D9E75' }}><i className="ti ti-check" style={{ marginRight: 4 }} />{msg}</span>}
        <button onClick={save} disabled={saving || !loaded} style={btn}>{saving ? t('login_wait') : t('save')}</button>
      </div>
    </div>
  );
}
